import Request from '@/jslib/dk-axios'

export const productList = (data) => {
  return Request({
    url: 'Product',
    method: 'GET',
    params: data,
  })
}

export const addProduct = (data) => {
  return Request({
    url: 'Product',
    method: 'POST',
    data,
  })
}

export const editProduct = (data) => {
  return Request({
    url: `Product/${data.uuid}`,
    method: 'PUT',
    data,
  })
}

export const delProduct = (data) => {
  return Request({
    url: `Product/${data.uuid}`,
    method: 'DELETE',
    data,
  })
}

export const productDetail = (data) => {
  return Request({
    url: `Product/${data.uuid}`,
    method: 'GET',
    params: data,
  })
}



// WEBPACK FOOTER //
// ./src/api/product.js